import {fetchAuthSession, signOut } from "aws-amplify/auth";
import {selectAccessToken, setLoginState, setTokens} from "../features/states/slices";
import {store} from "../app/store";
import {SendNullToken} from "../components/shared/UnityCommandsContext";

function buildTokenPayload(session) {
    const accessToken = session?.tokens?.accessToken?.toString?.();
    const idToken = session?.tokens?.idToken?.toString?.();

    if (!accessToken || !idToken) {
        return null;
    }

    return {
        accessToken,
        idToken,
        refreshToken: getRefreshTokenFromLocalStorage(),
    };
}

async function resolveAndStoreTokens(options) {
    const session = await fetchAuthSession(options);
    const tokens = buildTokenPayload(session);
    if (!tokens) {
        return null;
    }
    store.dispatch(setTokens(tokens));
    return tokens;
}

function getStoredAccessToken() {
    const accessToken = selectAccessToken(store.getState());
    return typeof accessToken === "string" && accessToken.length > 0 ? accessToken : null;
}

export async function getTokenValueFromAWS() {
    const storedAccessToken = getStoredAccessToken();
    if (storedAccessToken) {
        return storedAccessToken;
    }

    try {
        const tokens = await resolveAndStoreTokens();
        if (tokens?.accessToken) {
            return tokens.accessToken;
        }
    } catch (error) {
        // Fall through to force-refresh token fetch.
    }

    try {
        const refreshedTokens = await resolveAndStoreTokens({forceRefresh: true});
        return refreshedTokens?.accessToken ?? null;
    } catch (error) {
        return null;
    }
}

export function getRefreshTokenFromLocalStorage() {
    const clientId = process.env.REACT_APP_CLIENT_SECRET;
    const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
    const lastUser = localStorage.getItem(lastUserKey);
    const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.refreshToken`;
    return localStorage.getItem(refreshTokenKey);
}

export async function getNewTokenValueFromAWS() {
    try {
        const refreshedTokens = await resolveAndStoreTokens({forceRefresh: true});
        if (!refreshedTokens?.accessToken) {
            throw new Error("Missing authentication tokens");
        }
        return refreshedTokens.accessToken;
    } catch (error) {
        const storedAccessToken = getStoredAccessToken();
        if (storedAccessToken) {
            return storedAccessToken;
        }
        throw error;
    }
}

export async function SignOutOfClient(){
    try {
        await signOut();
        SendNullToken();
        store.dispatch(setLoginState(false));
    } catch (error) {
        console.log("error signing out: ", error);
    }
}
